import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Modal, Table } from 'antd';
import { useGetCountries } from 'api/countries/use-get-countries';
import type { ClientRes } from 'api/swagger';
import { findCountriesById } from 'shared/utils/countries';

interface InputWithSearchSimilarModalProps {
  isModalVisible: boolean;
  handleClose: () => void;
  clients: ClientRes[];
}

export const InputWithSearchSimilarModal: React.FC<InputWithSearchSimilarModalProps> = (props) => {
  const { isModalVisible, handleClose, clients } = props;
  const { t } = useTranslation('client');
  const { data: countries } = useGetCountries();

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, { id }: { id: number }) => <Link to={`/clients/${id}`}>{name}</Link>,
    },
    {
      title: 'Vat number',
      dataIndex: 'vatNumber',
      render: (vatNumber: string) => vatNumber,
    },
    {
      title: 'Country',
      dataIndex: 'legalCountryId',
      render: (legalCountryId: number) => {
        const country = findCountriesById(legalCountryId, countries);

        return country?.name;
      },
    },
  ];

  return (
    <Modal
      title={t('similar_clients_modal_header')}
      open={isModalVisible}
      footer={[
        <Button key='close-modal-button' type='primary' onClick={handleClose}>
          OK
        </Button>,
      ]}
      onCancel={handleClose}
      onOk={handleClose}>
      <Table dataSource={clients} columns={columns} pagination={false} />
    </Modal>
  );
};
